import { render, staticRenderFns } from "./ZoomSettings.vue?vue&type=template&id=39bda55d&"
import script from "./ZoomSettings.vue?vue&type=script&lang=js&"
export * from "./ZoomSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports